<template>
  <div id="main-content">
    <div class="wrapper">
      <div class="table-agile-info">
        <jm-crumbs />
        <jm-toolbar customize-field-name=""> </jm-toolbar>
        <el-form :inline="true" :model="searchData">
          <el-col
            v-for="item in dict.groups"
            :key="item.id"
            :xl="{ span: 3 }"
            :lg="{ span: 4 }"
            :md="{ span: 6 }"
            :sm="{ span: 8 }"
            :xs="{ span: 24 }"
            style="height: 28px; padding-left:10px;">
            <el-radio
              v-model="searchData.group_id"
              :label="item.id"
              @change="reLoad()"
              :title="`分组ID：${item.id}`">
              <i :class="`box group-${(item.id % 13) + 1}`"></i>
              {{ item.value }}({{ item.admin }})
            </el-radio>
          </el-col>
          <el-col>
            <p>&nbsp;</p>
          </el-col>
        </el-form>
        <jm-tableList
          url="/index/Teacher/getGroupTabelPage"
          :search-data="searchData"
          :refresh.sync="refresh">
          <el-table-column slot="lastColumn" label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="edit(scope, 0)">删除</el-button>
            </template>
          </el-table-column>
        </jm-tableList>
        <jm-tableList
          url="/index/Teacher/getGroupTabelPage"
          :search-data="searchData1"
          :refresh.sync="refresh1">
          <el-table-column slot="lastColumn" label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="edit(scope, searchData.group_id)">加入</el-button>
            </template>
          </el-table-column>
        </jm-tableList>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import '@/assets/css/group-color.css';

export default {
  data() {
    return {
      refresh: false,
      searchData: { gid: 1, group_id: 0 },
      refresh1: false,
      searchData1: { gid: 0, group_id: 0 },
      info: {
        userid: 0,
        group_id: 0
      },
      dict: {
        country: [],
        groups: []
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList
  },
  computed: {},
  methods: {
    handleEdit() {
      // 编辑
      this.$http
        ._post({
          url: 'index/Teacher/editTeacherGroup',
          data: this.info
        })
        .then((res) => {
          if (res.result === 0) {
            this.$message({
              type: 'success',
              message: '保存成功!'
            });
            this.reLoad();
          }
        });
    },
    edit(scope, gid) {
      // 编辑
      this.info = Object.assign(this.info, scope.row);
      this.info.group_id = gid;
      // console.log(this.info);
      this.handleEdit();
    },
    reLoad() {
      this.searchData1.group_id = this.searchData.group_id;
      if (this.searchData.group_id) {
        this.refresh = true;
        this.refresh1 = true;
      }
    }
  },
  created() {
    this.$http
      ._post({
        url: 'index/Teacher/getDic'
      })
      .then(({ data }) => {
        // 若指定 groupIds 则只展示
        if (this.$route.meta.groupIds && this.$route.meta.groupIds.length > 0) {
          let groupIds = this.$route.meta.groupIds;
          data.groups = data.groups.filter((item) => {
            return groupIds.indexOf(item.id) > -1;
          });
        }

        this.dict = data;
        this.searchData.group_id = this.dict.groups[0].id;
        this.searchData1.group_id = this.dict.groups[0].id;
        this.refresh = true;
        this.refresh1 = true;
      });
  }
};
</script>

<style scoped>
i.box {
  width: 10px;
  height: 10px;
  display: inline-block;
  margin-right: 5px;
}
</style>
